/* eslint-disable */

import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern(null, 'transactions', ({ Api, resource }) => ({
  actions: {
    async dashboard({ rootState }, { params, start, end }) {
      let resourcePath =  `${resource}/dashboard?start=${start ?? ''}&end=${end ?? ''}`;
      const { data } = await Api.get(rootState.serviceName, resourcePath, { params });
      return data;
    },
    async get({ rootState }, { params }) {
      const { data, headers } = await Api.get(
        rootState.serviceName,
        resource,
        { params }
      )
      return {
        data,
        total: Number(headers['x-total-count'])
      }
    },

    async getByCompany({ rootState }, { companyId, params }) {
      const { data, headers } = await Api.get(
        rootState.serviceName,
        `${resource}/company/${companyId}`,
        { params }
      )
      return {
        data,
        total: Number(headers['x-total-count'])
      }
    },

    async getMetadata({ rootState }, { transactionId, params }) {
      const { data, headers } = await Api.get(
        rootState.serviceName,
        `${resource}/${transactionId}/metadata`,
        { params }
      )
      return {
        data,
        total: Number(headers['x-total-count'])
      }
    },

    async count({ rootState }, { params }) {
      const { data } = await Api.get(
        rootState.serviceName,
        `${resource}/count`,
        { params }
      )
      return data
    },

    async findByCompany({ rootState }, { companyId, id, params }) {
      const { data } = await Api.get(
        rootState.serviceName,
        `${resource}/company/${companyId}/${id}`,
        { params }
      )
      return data
    },

    async find({ rootState }, { id, params }) {
      const { data } = await Api.get(
        rootState.serviceName,
        `${resource}/${id}`,
        { params }
      )
      return data
    },

    async delete({ rootState }, { id }) {
      await Api.delete(
        rootState.serviceName,
        `${resource}/${id}`
      )
    },

    async create({ rootState }, { dataForm }) {
      const { data } = await Api.post(
        rootState.serviceName,
        resource,
        dataForm
      )
      return data
    },

    async update({ rootState }, { id, dataForm }) {
      const { data } = await Api.patch(
        rootState.serviceName,
        `${resource}/${id}`,
        dataForm
      )
      return data
    },

    async getUrlDownload({ rootState }, { id, usernames, userId }) {
      const urlBase = await Api.getUrl(
        rootState.serviceName,
        resource
      )

      const params = new URLSearchParams({
        access_token: Api?.token ?? '',
        usernames: JSON.stringify(usernames),
        userId: userId ?? ''
      })

      return `${urlBase}/${id}/download?${params.toString()}`
    },

    async getUrlDownloadByCompany({ rootState }, { companyId, id, usernames, userId }) {
      const urlBase = await Api.getUrl(
        rootState.serviceName,
        resource
      )

      const params = new URLSearchParams({
        access_token: Api?.token ?? '',
        usernames: JSON.stringify(usernames),
        userId: userId ?? ''
      })

      return `${urlBase}/${companyId}/${id}/download?${params.toString()}`
    }
  }
}));
